import { JobApplicationStatusCodelist } from "./types/JobApplicationStatus";

export const openJobApplicationStatuses: JobApplicationStatusCodelist[] = [
  {
    code: "DRAFT",
  },
  {
    code: "SUBMITTED",
  },
  {
    code: "PRESENTED_TO_CLIENT",
  },
  {
    code: "INTERVIEW",
  },
];
